// Software built by  Adeweb Developer Africa
// portfolio website: https://adeweb-developer.vercel.app
// whatsApp Message: https://wa.me/23407043455416
// I am open for your software development gig, thank you

import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./OnboardingStyle.css";
import NextArrow from "../../assets/facingright.svg";
import BackArrow from "../../assets/goBackarrow.svg";
import CardOne from "../../assets/OnboardingCards/CardTwo.svg";
import LoveIcon from "../../assets/OnboardingCards/Loveiconbn.svg";
import ChatAssistance from "../../assets/OnboardingCards/HelpLoverr.svg";
import IkoroduLogo from "../../assets/OnboardingCards/Ikorodu-Dating-Logo.svg";
import { useNavigate } from "react-router-dom";
import "./DesktopOnboardingStyle.css";
import LoveLike from "../../assets/UserdetailsIcons/Lovelike.svg";
import DislikeBTN from "../../assets/UserdetailsIcons/DislikeBTN.svg";
import StarBtn from "../../assets/UserdetailsIcons/StarBtn.svg";
import Verify from "../../assets/verified.svg";
import SendAm from "../../assets/UserdetailsIcons/Sendmessage.svg";
import Notifii from "../../assets/Notifififif.svg";
import VeriG from "../../assets/statusverifiedWhite.svg";
import MatchBar from "../../assets/BottomNavBar/MatchBar.svg";
import MatchBardark from "../../assets/BottomNavBar/HomeLightt.svg";
import ViewMatch from "../../assets/BottomNavBar/ViewMatch.svg";
import ViewMatchLight from "../../assets/BottomNavBar/ViewMatchLight.svg";
import MessageLight from "../../assets/BottomNavBar/MessageLight.svg";
import Message from "../../assets/BottomNavBar/MessageActive.svg";
import Dating from "../../assets/BottomNavBar/DateProfile.svg";
import DatingWhite from "../../assets/BottomNavBar/DatingWhite.svg";
import FirstHook from "../../assets/IMG_2166.JPG";
import FirstHooks from "../../assets/IMG_2173.JPG";
import FirstHookd from "../../assets/IMG_2167.JPG";
import FirstHookf from "../../assets/IMG_2169.JPG";
import FirstHookg from "../../assets/IMG_2172.JPG";
import FirstHookh from "../../assets/IMG_2170.JPG";
import FirstHookj from "../../assets/IMG_2168.JPG";

import Smenu from "../../assets/OnboardingCards/SMenuu.svg";

import { FiZap, FiUserCheck, FiMapPin, FiShield } from "react-icons/fi";
import {
  FaUser,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCog,
  FaBirthdayCake,
  FaGenderless,
  FaHeart,
  FaInfoCircle,
  FaTrash,
} from "react-icons/fa";
import { FaUserShield } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import CloseMenuu from "../../assets/OnboardingCards/closeThisBar.svg";

const OnboardingScreen1 = ({ nextStep }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [sMenuActive, setSMenuActive] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const imageStyle = {
    width: isMobile ? "110%" : "50%",
    marginTop: isMobile ? "16%" : "7%",
    display: isMobile ? "flex" : "flex",
  };

  const boxStyle = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: 20,
    marginTop: "9rem",
    backgroundColor: "#f5f6f7",
    marginBottom: "5rem",
  };

  const onboardingBottomStyle = {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: 26,
    marginTop: "0rem",
    backgroundColor: "#fff",
    position: "relative",
  };

  const finishOnboardingg = () => {
    navigate("/signup");
  };

  const aboutus = () => {
    navigate("/about");
  };
  return (
    <div className="onboarding-screen">
      {sMenuActive && isMobile && (
        <div className="sMenuActive">
          <div className="user-infoo">
            <p>
              <FaUserShield /> <Link to="/terms">Terms and Conditions</Link>
            </p>
            <p>
              <FaInfoCircle /> <Link to="/disclaimer">Disclaimer</Link>
            </p>
            <p>
              <FaBirthdayCake /> <Link to="/about">About Us</Link>
            </p>
            <p>
              <FaUserShield /> <Link to="/privacy">Privacy Policy</Link>
            </p>

            <p>
              <img
                style={{
                  width: 21,
                  padding: 13,
                  backgroundColor: "#fafafa",
                  borderRadius: "50%",
                  marginRight: 10,
                }}
                src={ChatAssistance}
                alt="back button"
              />
              <Link to="/help">Need Help ?</Link>
            </p>
          </div>

          <div className="adewebWatermark">
            built by ||{" "}
            <a href="https://adeweb-developer.vercel.app">
              Adeweb Developer Africa
            </a>
            <img style={{ width: 14 }} src={Verify} alt="back button" />
          </div>
        </div>
      )}
      <div className="onboardingBackBTN">
        <button>
          <img style={{ width: 34 }} src={IkoroduLogo} alt="back button" />
        </button>

        {!isMobile && (
          <div className="sMenuActiveMobile">
            <div className="user-infooDesktop">
              <p>
                <FaUserShield
                  style={{
                    width: 21,
                    padding: 13,
                    backgroundColor: "#fafafa",
                    borderRadius: "50%",
                    marginRight: 10,
                  }}
                />{" "}
                <Link to="/terms">Terms and Conditions</Link>
              </p>
              <p>
                <FaInfoCircle
                  style={{
                    width: 21,
                    padding: 13,
                    backgroundColor: "#fafafa",
                    borderRadius: "50%",
                    marginRight: 10,
                  }}
                />{" "}
                <Link to="/disclaimer">Disclaimer</Link>
              </p>
              <p>
                <FaBirthdayCake
                  style={{
                    width: 21,
                    padding: 13,
                    backgroundColor: "#fafafa",
                    borderRadius: "50%",
                    marginRight: 10,
                  }}
                />{" "}
                <Link to="/about">About Us</Link>
              </p>
              <p>
                <FaUserShield
                  style={{
                    width: 21,
                    padding: 13,
                    backgroundColor: "#fafafa",
                    borderRadius: "50%",
                    marginRight: 10,
                  }}
                />{" "}
                <Link to="/privacy">Privacy Policy</Link>
              </p>

              <p>
                <img
                  style={{
                    width: 21,
                    padding: 13,
                    backgroundColor: "#fafafa",
                    borderRadius: "50%",
                    marginRight: 10,
                  }}
                  src={ChatAssistance}
                  alt="back button"
                />
                <Link to="/help">Need Help ?</Link>
              </p>
            </div>

            {/* <div className="adewebWatermark">
            built by || <a href="https://adeweb-developer.vercel.app" >Adeweb Developer Africa</a>
          <img style={{ width: 14 }} src={Verify} alt="back button" />
            
          </div> */}
          </div>
        )}

        {sMenuActive && (
          <button onClick={() => setSMenuActive(false)}>
            <img style={{ width: 17 }} src={CloseMenuu} alt="back button" />
          </button>
        )}

        {!sMenuActive && (
          <button onClick={() => setSMenuActive(true)}>
            <img style={{ width: 31 }} src={Smenu} alt="lover match" />
          </button>
        )}
      </div>
      <div
        style={!isMobile ? boxStyle : { backgroundColor: "#f5f6f7" }}
        className="onboardingTop"
      >
        {!isMobile && (
          <div className="onboardingCTA" style={{ width: "40%" }}>
            <h1>Start Your Love Story With Us at Ikorodu Dating Site</h1>
            <p
              style={{
                color: "#00000080",
                fontWeight: "400",
                fontSize: "16px",
              }}
            >
              We believe in the power of love and the importance of meaningful
              relationships. Our platform is designed to help you find your
              perfect match, whether you're looking for a serious relationship
              or a casual encounter.
            </p>
            <div className="buttonHolderCTA">
              <button onClick={finishOnboardingg}>Create your account</button>
              <button onClick={aboutus} className="readmore">
                Learn more
              </button>
            </div>
          </div>
        )}
        <img
          style={imageStyle}
          src={CardOne}
          className="iiimg"
          alt="back button"
        />

        {isMobile && (
          <div className="buttonHolderCTA">
            <button onClick={finishOnboardingg}>Create your account</button>
            <button onClick={aboutus} className="readmore">
              Learn more
            </button>
          </div>
        )}
      </div>

      <div className="otherSectionCta">
        <div className="otherSectionCtaInner">
          <div className="featurespage">
            <img style={{ width: 200 }} src={StarBtn} alt="lover boy" />
            <div>
              <h1>User-Friendly Experience</h1>
              <p>
                Our easy-to-use interface ensures you can focus on finding
                connections without any hassle.
              </p>
            </div>
          </div>
          <div className="featurespage">
            <div style={{ backgroundColor: "#000000" }} className="iconCta">
              <img style={{ width: 55 }} src={VeriG} alt="" />
            </div>
            {/* <img style={{width: 200}} src={DislikeBTN} alt="lover match" /> */}

            <div>
              <h1>Safe and Secure</h1>
              <p>
                Your privacy and safety are our top priorities. We use
                end-to-end encryption to protect your data and ensure all
                profiles are verified.
              </p>
            </div>
          </div>
          <div className="featurespage">
            <img src={LoveLike} alt="lover match" />
            <div>
              <h1>Swipe Right</h1>
              <p>
                Enjoy a Tinder-like experience with our swipe cards. Connect
                with people who catch your eye.
              </p>
            </div>
          </div>
          <div className="featurespage">
            <div className="iconCta">
              <img style={{ width: 45 }} src={SendAm} alt="send message" />
            </div>
            <div>
              <h1>Real-Time Chat</h1>
              <p>
                Engage in real-time conversations with potential matches. Get
                instant notifications and never miss a message.
              </p>
            </div>
          </div>
        </div>

        <div
          style={{
            width: "95%",
            marginTop: "5%",
          }}
          className="sectionfront"
        >
          <div className="oldtext">
            <h1>No Games. Just Connections.</h1>

            <p>
              Tired of the endless "what are we?" talk? We get it. Sometimes you
              just want to skip the small talk and find someone who is on the
              exact same page as you.
            </p>

            <div className="benefits-grid">
              <div className="benefit-item">
                <FiZap className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Zero Pressure</h3>
                  <p>
                    This is a judgment-free zone. State your intentions upfront
                    and find others doing the same.
                  </p>
                </div>
              </div>

              <div className="benefit-item">
                <FiUserCheck className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Verified Profiles</h3>
                  <p>
                    We prioritize real people. Our verification process ensures
                    who you see is who you meet.
                  </p>
                </div>
              </div>

              <div className="benefit-item">
                <FiMapPin className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Local & Ready</h3>
                  <p>
                    Find active members in Ikorodu who aren't looking to waste
                    time.
                  </p>
                </div>
              </div>

              <div className="benefit-item">
                <FiShield className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Total Privacy</h3>
                  <p>
                    Your business is yours. Encrypted messaging keeps your
                    conversations discreet.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="hooksBoxx">
            <div
              style={{
                width: "100%",
                marginTop: "0.2rem",
                marginBottom: "1rem",
              }}
              className="bentoGrid"
            >
              {isMobile ? (
                <div className="bentoTop">
                  <div className="bentotopone">
                    <div className="bentoChild">
                      <img
                        src={FirstHook}
                        alt="Casual Connection"
                        className="bentoImg"
                      />
                      <div className="bentoOverlay">
                        <h3>No Strings Attached</h3>
                      </div>
                    </div>

                    <div className="bentoChild">
                      <img
                        src={FirstHooks}
                        alt="Verified"
                        className="bentoImg"
                      />
                      <div className="bentoOverlay">
                        <h3>100% Verified</h3>
                      </div>
                    </div>
                  </div>
                  <div className="bentotoptwo">
                    <div className="bentoChild">
                      <img src={FirstHookd} alt="Local" className="bentoImg" />
                      <div className="bentoOverlay">
                        <h3>Right Near You</h3>
                      </div>
                    </div>

                    <div className="bentoChild">
                      <img
                        src={FirstHookf}
                        alt="Discreet"
                        className="bentoImg"
                      />
                      <div className="bentoOverlay">
                        <h3>Total Privacy</h3>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bentoTop">
                  <div className="bentoChild">
                    <img
                      src={FirstHook}
                      alt="Casual Connection"
                      className="bentoImg"
                    />
                    <div className="bentoOverlay">
                      <h3>No Strings Attached</h3>
                    </div>
                  </div>

                  <div className="bentoChild">
                    <img src={FirstHooks} alt="Verified" className="bentoImg" />
                    <div className="bentoOverlay">
                      <h3>100% Verified</h3>
                    </div>
                  </div>

                  <div className="bentoChild">
                    <img src={FirstHookd} alt="Local" className="bentoImg" />
                    <div className="bentoOverlay">
                      <h3>Right Near You</h3>
                    </div>
                  </div>

                  <div className="bentoChild">
                    <img src={FirstHookf} alt="Discreet" className="bentoImg" />
                    <div className="bentoOverlay">
                      <h3>Total Privacy</h3>
                    </div>
                  </div>
                </div>
              )}
              <div
                style={{
                  overflow: "hidden",
                  height: "450px",
                }}
                className="bentoBottom"
              >
                <img src={FirstHookh} alt="Discreet" className="bentoImg" />
                <div className="bentoOverlay">
                  <h3
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Find active members in Ikorodu ready to meet now.
                  </h3>
                  <p
                    style={{
                      color: "#ffffff90",
                      fontWeight: "500",
                    }}
                  >
                    Encrypted messaging to keep your business your business.
                  </p>
                  <p
                    style={{
                      color: "#ffffff90",
                      fontWeight: "500",
                    }}
                  >
                    We prioritize real people so who you see is who you meet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="featurespageBottom">
          <div className="featurespageBottomChild">
            <h1>Advanced Matching Algorithm</h1>
            <p style={{ marginTop: "1%", color: "#00000076" }}>
              We use sophisticated algorithms to match you with individuals who
              share your interests and values.
            </p>

            <p style={{ marginTop: "2%", color: "#00000046" }}>
              Create and update your profile to reflect your personality and
              preferences. Let others know what makes you unique.
            </p>

            <p style={{ marginTop: "2%", color: "#00000030" }}>
              Share your thoughts and feelings with status updates. Let your
              matches get to know you better.
            </p>
          </div>
          <div className="featurespageBottomIcon">
            <div style={{ backgroundColor: "#000000" }} className="iconCta">
              <img style={{ width: 45 }} src={MatchBar} alt="send message" />
            </div>

            <div style={{ backgroundColor: "#000000" }} className="iconCta">
              <img style={{ width: 45 }} src={DatingWhite} alt="send message" />
            </div>

            <div className="iconCta">
              <img
                style={{ width: 45 }}
                src={ViewMatchLight}
                alt="send message"
              />
            </div>
            <div style={{ backgroundColor: "#000000" }} className="iconCta">
              <img style={{ width: 45 }} src={Message} alt="send message" />
            </div>
          </div>
        </div>
      </div>

      <div
        style={!isMobile ? onboardingBottomStyle : { backgroundColor: "#fff" }}
        className="onboardingBottom"
      >
        <img style={{ width: 70 }} src={LoveIcon} alt="love icon" />

        <div>
          <h1 style={{ fontWeight: "700", fontSize: 22 }}>
            Welcome to Ikorodu dating Site
          </h1>
          <p>Find your perfect match today, Odonguyan, Adamo and so on....</p>
          <button
            style={{
              marginTop: "1.6rem",
            }}
            onClick={nextStep}
          >
            Next
            <img src={NextArrow} alt="back button" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnboardingScreen1;
